import { connect } from 'react-redux'
import get from 'lodash/get';

import {
  openSideBarAction as onOpenSideBarAction,
  closeSideBarAction as onCloseSideBarAction,
  openCarsSecondSideBar as onOpenCarsSecondSideBar,
  closeCarsSecondSideBar as onCloseCarsSecondSideBar,
  openDriversSecondSideBar as onCpenDriversSecondSideBar,
  closeDriversSecondSideBar as onCloseDriversSecondSideBar,
} from '../../actions/appStateActions'

const mapStateToProps = (state) => ({
  isSideBarOpen: get(state, ['appState', 'isSideBarOpen'], true),
  isCarsSecondSideBarOpen: get(state, ['appState', 'isCarsSecondSideBarOpen'], false),
  isDriversSecondBarOpen: get(state, ['appState', 'isDriversSecondBarOpen'], false),
});

const mapDispatchToProps = {
  onOpenSideBarAction,
  onCloseSideBarAction,
  onOpenCarsSecondSideBar,
  onCloseCarsSecondSideBar,
  onCpenDriversSecondSideBar,
  onCloseDriversSecondSideBar,
}

const withAppState = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withAppState }